<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">轮播列表</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="列表名称" prop="Title">
            <el-input v-model="Title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="createGroup">创建分组</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="handleSelectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column prop="GroupName" label="名称"></el-table-column>
              <el-table-column label="摄像头数量">
                <template slot-scope="scope">{{ scope.row.Items.length }}</template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="160">
                <template slot-scope="scope">
                  <!-- <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button> -->
                  <el-button @click="editClick(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    style="color:red;"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <!-- 树形节点弹窗 -->
    <div class="treeBox" v-if="showTree">
      <p class="treeTittle">{{ this.GroupId ? "编辑分组": "创建分组" }}</p>
      <el-form class="zj-search-form2" ref="form2" :label-width="labelWidth" @submit.native.prevent>
        <el-form-item label="名称" style="width:100%;font-size:16px;">
          <el-input v-model="addGroupName" placeholder="请输入名称" style="width:70%;font-size:14px;"></el-input>
        </el-form-item>
      </el-form>
      <img class="treeClose" src="../../../../../../assets/close.png" alt @click="changeShowTree" />
      <div class="treeOutLine">
        <el-tree
          style="height:100%;"
          v-loading="loading"
          show-checkbox
          check-on-click-node
          :element-loading-text="loadingText"
          :data="nodes"
          node-key="id"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :default-checked-keys="defaultArr"
          class="zj-demo-player-tree-device-tree"
          ref="tree"
        ></el-tree>
      </div>
      <el-botton class="addBtn" @click="addGroup">{{ this.GroupId ? "编辑分组": "新增分组" }}</el-botton>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";
import ZJApp from "../../../../../app";
export default {
  name: "swiperVideoList",
  controller: "UI",
  action: "swiperVideoList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      nodes: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      Title: "",
      showTree: false,
      loading: false,
      loadingText: "加载中...",
      // checkedArr:[],
      defaultArr: [],
      addGroupName: "",
      GroupId: "",
      selectData: []
    };
  },
  created: function() {},
  mounted: function() {
    this.search();
    this.searchNode();
    this.logInfo.ActionName = "轮播列表查看";
    this.logInfo.LogMessage = "轮播列表查看";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "轮播管理列表页面";
    this.addOperationLog();
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    addGroup() {
      if (this.addGroupName == "") {
        this.errmsg("名称不能为空！");
        return;
      }
      let checkedAllArr = [];
      let nodeData = this.$refs.tree.getCheckedNodes();
      //  console.log("nodeData")
      //  console.log(nodeData)
      nodeData.forEach(item => {
        if (item.children.length == 0) {
          let obj = {
            GroupId: this.GroupId,
            ItemId: item.id,
            ItemName: item.label,
            Index: checkedAllArr.length
          };
          checkedAllArr.push(obj);
        }
      });
      if (this.GroupId) {
        new MyApis.SwiperListApi()
          .UpdatePollingGroup({
            GroupId: this.GroupId,
            GroupName: this.addGroupName,
            BelongUser: "",
            Index: "0",
            Items: checkedAllArr,
            Modifier: ZJApp.ZJUser.current.UserName,
            ModifyTime: new Date(),
            Creater: ZJApp.ZJUser.current.UserName,
            CreateTime: new Date(),
            Validity: 1
          })
          .then(r => {
            // r = r.data.Data;
            this.logInfo.ActionName = "修改分组轮播";
            this.logInfo.LogMessage = r
              ? "修改分组轮播成功"
              : "修改分组轮播失败";
            this.logInfo.ModuleName = "视频监控";
            this.logInfo.PageName = "轮播管理列表页面";
            this.addOperationLog();
            this.changeShowTree();
            this.search();
            this.addGroupName = "";
            // console.log("this.nodes")
            console.log(r);
          })
          .catch(e => {
            console.error(e);
            this.$message({
              message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
              type: "error"
            });
          });
      } else {
        new MyApis.SwiperListApi()
          .AddPollingGroup({
            GroupId: ZJApp.ZJUtils.uuid(),
            GroupName: this.addGroupName,
            BelongUser: "",
            Index: "0",
            Items: checkedAllArr,
            Modifier: ZJApp.ZJUser.current.UserName,
            ModifyTime: new Date(),
            Creater: ZJApp.ZJUser.current.UserName,
            CreateTime: new Date(),
            Validity: 1
          })
          .then(r => {
            // r = r.data.Data;
            this.logInfo.ActionName = "创建分组轮播";
            this.logInfo.LogMessage = r
              ? "创建分组轮播成功"
              : "创建分组轮播失败";
            this.logInfo.ModuleName = "视频监控";
            this.logInfo.PageName = "轮播管理列表页面";
            this.addOperationLog();
            this.changeShowTree();
            this.search();
            this.addGroupName = "";
            // console.log("this.nodes")
            console.log(r);
          })
          .catch(e => {
            console.error(e);
            this.$message({
              message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
              type: "error"
            });
          });
      }
    },
    changeShowTree() {
      this.showTree = !this.showTree;
    },
    createGroup() {
      this.GroupId = "";
      this.addGroupName = "";
      this.defaultArr = [];
      this.showTree = !this.showTree;
    },
    searchNode() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
          DeviceType: "SubSystem.Monitor.EquipmentType.Monitor"
        })
        .then(r => {
          r = r.data.Data;
          this.nodes = that.convertToTreeNodesfunction(r);
        
        })
        .catch(e => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error"
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: []
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: []
          });
        }
        result.push(region);
      }
      // console.log("result")
      // console.log(result)
      return result;
    },
    search() {
      let searchInfo = {
        GroupName: this.Title,
        PageSize: this.pageSize,
        PageIndex: this.currentPage
      };
      new MyApis.SwiperListApi()
        .GetGroupPagingList(searchInfo)
        .then(r => {
          // console.log("1");
          // console.log(r)
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.Title = "";
      this.search();
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //编辑按钮
    editClick(index, row) {
      console.log(index, row);
      this.changeShowTree();
      this.editData = row;
      this.addGroupName = row.GroupName;
      this.GroupId = row.GroupId;
      let data = row.Items;
      let arr = [];
      data.forEach(item => {
        //  let obj={
        //    label:item.ItemName,
        //    id:item.ItemId,
        //    children:[]
        //  }
        // this.$refs.tree.setCurrentNode(item.ItemId)
        arr.push(item.ItemId);
      });
      this.defaultArr = arr;
      //  console.log(this.defaultArr)
      this.$refs.tree && this.$refs.tree.setCheckedNodes(this.defaultArr);
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // console.log("selectData")
            // console.log(selectData)
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach(item => {
                new MyApis.SwiperListApi()
                  .DelPollingGroup(item)
                  .then(r => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch(e => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then(r => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                    this.logInfo.ActionName = "轮播删除";
                    this.logInfo.LogMessage = "轮播删除";
                    this.logInfo.ModuleName = "视频监控";
                    this.logInfo.PageName = "轮播管理列表页面";
                    this.addOperationLog();
                    this.search();
                  }
                })
                .catch(e => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!"
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          new MyApis.SwiperListApi()
            .DelPollingGroup(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.logInfo.ActionName = "轮播删除";
              this.logInfo.LogMessage = r ? "轮播删除成功" : "轮播删除失败";
              this.logInfo.ModuleName = "视频监控";
              this.logInfo.PageName = "轮播管理列表页面";
              this.addOperationLog();
              this.search();
            })
            .catch(e => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  }
};
</script>
<style scoped>
.treeBox {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 500px;
  overflow: auto;
  background: #003566;
  border: 1px solid #00bcfe;
  padding: 5px 20px 20px;
  margin-left: -220px;
  margin-top: -260px;
}
.treeTittle {
  font-size: 20px;
  color: #ffffff;
}
.treeClose {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 15px;
}
.treeOutLine {
  width: 100%;
  height: 70%;
  overflow: auto;
}
.addBtn {
  display: block;
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  border-radius: 10px;
  background: #2ac1ff;
  cursor: pointer;
}
</style>
